const CustomEvents = {
  ADD_TO_CART: "addToCart",
  ADD_TO_LOCAL_STORAGE: "addToLocalStorage",
  OPEN_TAB_FROM_LINK: "openTabFromLink",
  UPDATE_SHOP_CART: "updateShopCart"
};

export default CustomEvents;
